import React from "react";
import ContactDetails from "./ContactDetails";


const Support = () => {
    return (
        <ContactDetails />
    )
};

export default Support;